var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBar9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 47,
    viewBox: "0 0 57 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54.0609 38.2078H14.9625C13.3594 38.2078 12.0234 36.8719 12.0234 35.2688V30.4594C12.0234 29.925 12.3797 29.5688 12.9141 29.5688C13.4484 29.5688 13.8047 29.925 13.8047 30.4594V35.2688C13.8047 35.8922 14.3391 36.4266 14.9625 36.4266H54.0609C54.6844 36.4266 55.2188 35.8922 55.2188 35.2688V11.5782C55.2188 10.9547 54.6844 10.4203 54.0609 10.4203H14.9625C14.3391 10.4203 13.8047 10.9547 13.8047 11.5782V17.011C13.8047 17.5453 13.4484 17.9016 12.9141 17.9016C12.3797 17.9016 12.0234 17.5453 12.0234 17.011V11.5782C12.0234 9.97504 13.3594 8.6391 14.9625 8.6391H54.0609C55.6641 8.6391 57 9.97504 57 11.5782V35.3579C57 36.8719 55.6641 38.2078 54.0609 38.2078Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.4546 23.4234C39.4546 26.0953 37.228 28.3218 34.5562 28.3218C31.8843 28.3218 29.6577 26.0953 29.6577 23.4234C29.6577 20.7515 31.8843 18.525 34.5562 18.525C37.228 18.525 39.4546 20.7515 39.4546 23.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M52.1015 17.3672C49.964 17.3672 48.2718 15.675 48.2718 13.5375C48.2718 13.0922 47.9156 12.6469 47.3812 12.6469H21.7312C21.1968 12.6469 20.8406 13.0922 20.8406 13.5375C20.8406 15.675 19.1484 17.3672 17.0109 17.3672C16.5656 17.3672 16.1202 17.8125 16.1202 18.2579V28.5C16.1202 29.0344 16.5656 29.3907 17.0109 29.3907C19.1484 29.3907 20.8406 31.0829 20.8406 33.2204C20.8406 33.7547 21.1968 34.111 21.7312 34.111H47.3812C47.9156 34.111 48.2718 33.7547 48.2718 33.2204C48.2718 31.0829 49.964 29.3907 52.1015 29.3907C52.5468 29.3907 52.9921 29.0344 52.9921 28.5V18.2579C52.9921 17.8125 52.5468 17.3672 52.1015 17.3672ZM34.5562 30.1032C30.8156 30.1032 27.8765 27.075 27.8765 23.4235C27.8765 19.6829 30.9046 16.7438 34.5562 16.7438C38.2077 16.7438 41.2359 19.7719 41.2359 23.4235C41.2359 27.075 38.2077 30.1032 34.5562 30.1032Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37.6733 43.1953H30.7264C30.1921 43.1953 29.8358 42.8391 29.8358 42.3047C29.8358 41.7703 30.1921 41.4141 30.7264 41.4141H37.6733C38.2077 41.4141 38.5639 41.7703 38.5639 42.3047C38.5639 42.8391 38.1186 43.1953 37.6733 43.1953Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.739 42.3047C25.739 42.0375 25.8281 41.8594 26.0062 41.6813C26.5406 41.1469 27.5203 41.5032 27.5203 42.3047C27.5203 43.4625 25.739 43.5516 25.739 42.3047Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.4922 46.8469H17.5453C17.0109 46.8469 16.6547 46.4906 16.6547 45.9562C16.6547 45.4219 17.0109 45.0656 17.5453 45.0656H24.4922C25.0265 45.0656 25.3828 45.4219 25.3828 45.9562C25.3828 46.4906 25.0265 46.8469 24.4922 46.8469Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.5375 46.8468C13.0031 46.8468 12.6469 46.4906 12.6469 45.9562C12.6469 45.689 12.7359 45.5109 12.914 45.3328C13.4484 44.7984 14.4281 45.1546 14.4281 45.9562C14.4281 46.4015 13.9828 46.8468 13.5375 46.8468Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M30.1031 1.78125H23.1563C22.6219 1.78125 22.2656 1.425 22.2656 0.890625C22.2656 0.35625 22.6219 0 23.1563 0H30.1031C30.6375 0 30.9937 0.35625 30.9937 0.890625C30.9937 1.425 30.5484 1.78125 30.1031 1.78125Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.525 1.60312C18.3469 1.425 18.2578 1.24687 18.2578 0.979687C18.2578 -0.178125 20.0391 -0.178125 20.0391 0.979687C20.0391 1.24687 19.95 1.425 19.7719 1.60312C19.4156 1.95937 18.7922 1.87031 18.525 1.60312Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M43.7296 5.4328H36.7827C36.2483 5.4328 35.8921 5.07655 35.8921 4.54218C35.8921 4.0078 36.2483 3.65155 36.7827 3.65155H43.7296C44.264 3.65155 44.6202 4.0078 44.6202 4.54218C44.6202 5.07655 44.1749 5.4328 43.7296 5.4328Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M32.0625 5.16561C31.7062 4.80936 31.7062 4.27499 32.0625 3.91874C32.4187 3.56249 32.9531 3.56249 33.3094 3.91874C33.6656 4.27499 33.6656 4.80936 33.3094 5.16561C32.9531 5.52186 32.4187 5.52186 32.0625 5.16561Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M9.79688 20.4844H0.890625C0.35625 20.4844 0 20.1281 0 19.5938C0 19.0594 0.35625 18.7031 0.890625 18.7031H9.79688C10.3313 18.7031 10.6875 19.0594 10.6875 19.5938C10.6875 20.1281 10.3313 20.4844 9.79688 20.4844Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M13.6265 24.314H6.85779C6.32341 24.314 5.96716 23.9578 5.96716 23.4234C5.96716 22.889 6.32341 22.5328 6.85779 22.5328H13.6265C14.1609 22.5328 14.5172 22.889 14.5172 23.4234C14.5172 23.9578 14.1609 24.314 13.6265 24.314Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M9.79688 28.1437H0.890625C0.35625 28.1437 0 27.7875 0 27.2531C0 26.7187 0.35625 26.3625 0.890625 26.3625H9.79688C10.3313 26.3625 10.6875 26.7187 10.6875 27.2531C10.6875 27.7875 10.3313 28.1437 9.79688 28.1437Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar9);
export default __webpack_public_path__ + "static/media/bar9.bf499eef3c4a26bd16f81b3f27d78312.svg";
export { ForwardRef as ReactComponent };